import { forwardRef } from 'react';
import { type RequireIf } from '../../../../../@types/build';
import { enhancedSelect, enhancedSelectIcon, enhancedSelectLabel, enhancedSelectWithIcon } from './enhanced-select-box.css';
import { SelectBox, type SelectBoxProps } from './select-box.component';

type EnhancedSelectBoxBaseProps = Omit<SelectBoxProps, 'selectSize'> & {
	icon?: JSX.Element;
	selectClassName?: string;
};

export type EnhancedSelectBoxProps = RequireIf<EnhancedSelectBoxBaseProps, { id: string }, { label: string }>;

export const EnhancedSelectBox = forwardRef<HTMLSelectElement, EnhancedSelectBoxProps>(
	({ label, id, required, icon, employee, className = '', selectClassName = '', ...selectProps }, ref) => {
		const selectClass = `${selectClassName} ${enhancedSelect} ${icon ? enhancedSelectWithIcon : ''} bg-theme-white ${
			employee ? '' : 'hover-b--theme-primary'
		}`;
		const internalClass = employee ? 'theme-internal' : '';
		return (
			<div className={`${className} minw-maxc dib relative pt2`}>
				{label && id ? (
					<label htmlFor={id} className={`${enhancedSelectLabel} f6 absolute ${internalClass}`}>
						{label} {required && <span className="theme-error">*</span>}
					</label>
				) : null}
				<span className="relative">
					{icon ? <div className={`disableClickEvents absolute flex ${enhancedSelectIcon} ${internalClass}`}>{icon}</div> : null}
					<SelectBox
						{...selectProps}
						selectSize="DEFAULT"
						id={id}
						required={required}
						className={selectClass}
						employee={employee}
						ref={ref}
					/>
				</span>
			</div>
		);
	}
);
